var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 35.101 35.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.014,35.31H7.087c-3.908,0-7.087-3.179-7.087-7.087V7.087C0,3.179,3.179,0,7.087,0h20.927c3.908,0,7.087,3.179,7.087,7.087v21.136c0,3.908-3.179,7.087-7.087,7.087ZM7.087,2.174c-2.709,0-4.913,2.204-4.913,4.913v21.136c0,2.709,2.204,4.913,4.913,4.913h20.927c2.709,0,4.913-2.204,4.913-4.913V7.087c0-2.709-2.204-4.913-4.913-4.913H7.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.414,21.256h-1.07c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.07c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.152,21.256h-1.07c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.07c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.414,27.685h-1.07c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.07c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.152,27.685h-1.07c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.07c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.889,21.256h-1.069c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.069c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.627,21.256h-1.069c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h1.069c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.18,27.878h-7.312c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h7.312c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.637,15.27h-14.41c-2.433,0-4.413-1.979-4.413-4.412s1.979-4.412,4.413-4.412h14.41c2.433,0,4.412,1.979,4.412,4.412s-1.979,4.412-4.412,4.412ZM10.227,8.619c-1.234,0-2.239,1.004-2.239,2.238s1.004,2.238,2.239,2.238h14.41c1.234,0,2.238-1.004,2.238-2.238s-1.004-2.238-2.238-2.238h-14.41Z",
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/Values.50ec9cbc.svg";
export { ForwardRef as ReactComponent };